import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';

const Loading = ({ full, small, className, loadingTitle, loadingDescription }) => (
  <div
    className={[
      styles.loading,
      full ? styles.full : null,
      small ? styles.small : null,
      className,
    ].join(' ')}
  >
    <div className={styles.createLoading}>
      <img src="/static/images/wizard/wait1.gif" alt="loading..." className={styles.loadingGif} />
      <h2 className={styles.loadingTitle}>{loadingTitle}</h2>
      <p className={styles.loadingDescription}>{loadingDescription}</p>
    </div>
  </div>
);
Loading.propTypes = {
  full: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
  loadingTitle: PropTypes.string,
  loadingDescription: PropTypes.string,
};

Loading.defaultProps = {
  full: false,
  small: false,
  loadingDescription: '',
  className: '',
  loadingTitle: '',
};

export default Loading;
